import React from 'react'
import { Button, ButtonProps } from 'antd'
import { useAuth } from '@/hooks/useAuth'

export interface ActionButtonProps extends ButtonProps {
  authCode?: string
  ownerId?: string
}

const ActionButton: React.FC<ActionButtonProps> = ({ authCode, ownerId, disabled, ...rest }) => {
  const { hasAuth } = useAuth()
  // 没有传 authCode 视为不需要权限
  const canUse = !authCode || hasAuth(authCode, ownerId)

  return <Button disabled={disabled || !canUse} {...rest} />
}

export default ActionButton